module.exports = __webpack_public_path__ + "img/guide-student10.f4e7ce1b.png";